import { useSubscription, PlanType, BillingPeriod } from '@/hooks/useSubscription';
import { Badge } from '@/components/ui/badge';
import { Crown, Zap, User } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PlanBadgeProps {
  plan?: PlanType;
  period?: BillingPeriod;
  className?: string;
  showIcon?: boolean;
}

export function PlanBadge({ plan: overridePlan, period: overridePeriod, className, showIcon = true }: PlanBadgeProps) {
  const { plan: userPlan, billingPeriod } = useSubscription();
  const plan = overridePlan ?? userPlan;
  const period = overridePeriod ?? billingPeriod;

  if (plan === 'free') {
    return (
      <Badge className={cn('gap-1 font-semibold bg-muted text-muted-foreground border-border', className)}>
        {showIcon && <User className="h-3 w-3" />}
        Free
      </Badge>
    );
  }

  const isAnnual = period === 'annual';
  return (
    <Badge
      className={cn(
        'gap-1 font-semibold border-transparent text-white',
        isAnnual
          ? 'bg-gradient-to-r from-violet-600 to-purple-600'
          : 'bg-gradient-to-r from-amber-500 to-orange-500',
        className
      )}
    >
      {showIcon && (isAnnual ? <Crown className="h-3 w-3" /> : <Zap className="h-3 w-3" />)}
      {isAnnual ? 'Anual' : 'Mensal'}
    </Badge>
  );
}
